import 'src/pages/userComponents/userStyle.scss';
import 'antd/dist/antd.css';
import '../summarypage.scss';

import { Button, Col, Menu, Row, message } from 'antd';
import { GiftOutlined, LoadingOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';

import TextComponent from '@sharedComponent/typography/TextComponent';
import { images } from '@assets/img';
import StepButton from '@pages/userComponents/Step-Button/StepButton';
import { Link, useHistory } from 'react-router-dom';
import AppLoader from '@sharedComponent/app-loader';

// import '../userStyle.scss';

const SummaryPresentational = ({ feeData, isFeeLoading }) => {
	const [regFee, setRegFee] = useState(0);
	const [carInsuranceFee, setCarInsuranceFee] = useState(0);
	const [monthlyFee, setMonthlyFee] = useState(0);
	const [cardCancellationFee, setCardCancellationFee] = useState(0);
	const [sifUploadFee, setSifUploadFee] = useState(0);
	const [wpsPersonalBankAccountFee, setWpsPersonalBankAccountFee] = useState(0);
	const [wpsMinimumMonthlyBillingFee, setWpsMinimumMonthlyBillingFee] = useState(0);
	const [nonWPSPersonalBankAccountFee, setNonWPSPersonalBankAccountFee] = useState(0);
	const [numberOfBankAccounts, setNumberOfBankAccounts] = useState(0);
	const [numberOfPayrollCards, setNumberOfPayrollCards] = useState(0);
	const [specialComd, setSpecialComd] = useState([]);
	const [wpsProcessingFee, setWpsProcessingFee] = useState(0);
	const [nonWPSProcessingFee, setNonWpsProcessingFee] = useState(0);
	const history = useHistory();

	useEffect(() => {
		if (feeData && feeData) {
			setRegFee(feeData.registrationFee || 0);
			setCarInsuranceFee(feeData.cardIssuanceFee || 0);
			setMonthlyFee(feeData.monthlyFee || 0);
			setCardCancellationFee(feeData.cardCancellationFee || 0);
			setSifUploadFee(feeData.sifUploadFee || 0);
			setWpsPersonalBankAccountFee(feeData.wpsPersonalBankAccountFee || 0);
			setWpsMinimumMonthlyBillingFee(feeData.wpsMinimumMonthlyBillingFee || 0);
			setNonWPSPersonalBankAccountFee(feeData.nonWPSPersonalBankAccountFee || 0);
			setNumberOfBankAccounts(feeData.numberOfBankAccounts || 0);
			setNumberOfPayrollCards(feeData.numberOfPayrollCards || 0);
			setSpecialComd(
				feeData.specialComment && feeData.specialComment !== '' && JSON.parse(feeData.specialComment).sComments
					? JSON.parse(feeData.specialComment).sComments.filter((sComd) => sComd.checked === true)
					: []
			);
			console.log('SPECI ::', feeData ? feeData : '');
			setWpsProcessingFee(feeData.wpsProcessingFee || 0);
			setNonWpsProcessingFee(feeData.nonWPSProcessingFee || 0);
		}
	}, [feeData]);
	return (
		<div>
			<Col>
				{isFeeLoading ? (
					<AppLoader />
				) : (
					<>
						<div className="headercontainer">
							<div>
								<div className="summary_headercontainer">
									<TextComponent className="heading_2_text">Summary</TextComponent>
								</div>
								<div className="summary_wrapper">
									<div className="summary_container">
										<div className="summaryLhsContainer">
											<div className="summaryLhs">
												<TextComponent className="priceDescriptionText">Number of C3Pay Cards</TextComponent>
											</div>
										</div>
										<div className="summaryRhsContainer">
											<div className="summaryRhs">
												{' '}
												<TextComponent className="pricetext">
													{numberOfPayrollCards > 0 ? numberOfPayrollCards : '0'}
												</TextComponent>
											</div>
										</div>
									</div>
									<div className="summary_container">
										<div className="summaryLhsContainer">
											<div className="summaryLhs">
												<TextComponent className="priceDescriptionText">Number of Bank Accounts</TextComponent>
											</div>
										</div>
										<div className="summaryRhsContainer">
											<div className="summaryRhs">
												{' '}
												<TextComponent className="pricetext">
													{numberOfBankAccounts > 0 ? numberOfBankAccounts : 0}
												</TextComponent>
											</div>
										</div>
									</div>
								</div>
								<div className="summary_wrapper">
									<div className="summary_container">
										<div className="summaryLhsContainer">
											<div className="summaryLhs">
												<TextComponent className="priceDescriptionText">Registration Fee per Trade License</TextComponent>
											</div>
										</div>
										{regFee === 0 ? (
											<div className="summaryRhsContainer">
												{/* <TextComponent className="summary_strike_text">AED {regFee} </TextComponent> */}
												<div className="paddingAdjuster">
													<TextComponent className="bold_free_text">{'FREE'}</TextComponent>
												</div>
											</div>
										) : (
											<TextComponent className="pricetext">AED {regFee}</TextComponent>
										)}
									</div>
									<div className="summary_container">
										<div className="summaryLhsContainer">
											<div className="summaryLhs">
												<TextComponent className="priceDescriptionText">Card Issuance Fee (One-time)</TextComponent>
											</div>
										</div>
										<div className="summaryRhsContainer">
											{carInsuranceFee > 0 ? (
												<TextComponent className="pricetext">AED {carInsuranceFee}</TextComponent>
											) : (
												<TextComponent className="bold_free_text">{'FREE'}</TextComponent>
											)}
										</div>
									</div>
									<div className="summary_container">
										<div className="summaryLhsContainer">
											<div className="summaryLhs">
												<TextComponent className="priceDescriptionText">Monthly Fee (On all active Cards)</TextComponent>
											</div>
										</div>
										<div className="summaryRhsContainer">
											<div className="summaryRhs">
												{' '}
												<TextComponent className="pricetext">AED {monthlyFee > 0 ? monthlyFee : '0'}</TextComponent>
											</div>
										</div>
									</div>
									<div className="summary_container">
										<div className="summaryLhsContainer">
											<div className="summaryLhs">
												<TextComponent className="priceDescriptionText">SIF Upload Changes</TextComponent>
											</div>
										</div>
										<div className="summaryRhsContainer">
											<TextComponent className="bold_free_text">{sifUploadFee > 0 ? sifUploadFee : 'FREE'}</TextComponent>
										</div>
									</div>
									<div className="summary_gift_container">
										<img style={{ marginLeft: '-9px' }} src={images.gift} />
										<TextComponent className="heading_gift_text">
											Unlimited FREE Withdrawals on RAKBANK and C3Pay ATMs
										</TextComponent>
									</div>
									{specialComd &&
										specialComd.map((comd) => (
											<div className="summary_gift_container">
												<TextComponent className="heading_gift_text">{comd.sComment}</TextComponent>
											</div>
										))}
								</div>
								<div className="summary_wrapper">
									<div className="summary_container">
										<text className="optionalservice_text">
											OPTIONAL SERVICE- Only invoiced if you want to process salaries into personal bank accounts with Edenred.
										</text>
									</div>

									<div className="summary_container">
										<div className="summaryLhsContainer">
											<div className="summaryLhs">
												<TextComponent className="priceDescriptionText">
													For processing WPS salaries on any personal bank accounts through Edenred
												</TextComponent>
											</div>
										</div>
										<div className="summaryRhsContainer">
											<div className="summaryRhs">
												{' '}
												<TextComponent className="pricetext">
													AED {wpsProcessingFee > 0 ? wpsProcessingFee : '0'}
												</TextComponent>
											</div>
										</div>
									</div>
									<div className="summary_container">
										<div className="summaryLhsContainer">
											<div className="summaryLhs">
												<TextComponent className="priceDescriptionText">
													Minimum Billing (Only for WPS bank accounts)
												</TextComponent>
											</div>
										</div>
										<div className="summaryRhsContainer">
											<div className="summaryRhs">
												{' '}
												<TextComponent className="pricetext">
													AED {wpsMinimumMonthlyBillingFee > 0 ? wpsMinimumMonthlyBillingFee : '0'}
												</TextComponent>
											</div>
										</div>
									</div>
									<div className="summary_container">
										<div className="summaryLhsContainer">
											<div className="summaryLhs">
												<TextComponent className="priceDescriptionText">
													For processing non WPS salaries on any personal bank accounts through Edenred
												</TextComponent>
											</div>
										</div>
										<div className="summaryRhsContainer">
											<div className="summaryRhs">
												{' '}
												<TextComponent className="pricetext">
													AED {nonWPSProcessingFee > 0 ? nonWPSProcessingFee : '0'}
												</TextComponent>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="link_container">
								<a
									href="/tos"
									// onClick={(e) => {
									// 	e.preventDefault();
									// 	history.push('')
									// }}
									target="_blank"
									className="clickherebtn">
									Click here to view the full T&Cs
								</a>
							</div>
						</div>
						<StepButton handleNext={() => history.push('/user/signature/1')} buttonText={'Next'} />
					</>
				)}
			</Col>
		</div>
	);
};
export default SummaryPresentational;
